<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Accounts</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Subscription</mat-label>
    <mat-select [(ngModel)]="filter_options.subscription" matTooltip="Filter accounts by subscription." name="subscription">
      <mat-option value="">All</mat-option>
      <mat-option value="premium">Premium</mat-option>
      <mat-option value="advanced">Advanced</mat-option>
      <mat-option value="basic">Basic</mat-option>
      <mat-option value="free">Free</mat-option>
    </mat-select>
    <mat-hint>Use this to filter accounts by subscription.</mat-hint>
  </mat-form-field>

  <div class="full-width">
    <mat-checkbox [(ngModel)]="filter_options.include_merged_accounts" matTooltip="When enabled, merged accounts will be included in the list of results." name="include_merged_accounts">
      Include "Merged" Accounts.
    </mat-checkbox>
    <mat-hint>When enabled, merged accounts will be included in the list of results.</mat-hint>
  </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filter
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon> clear_all</mat-icon> Clear Filter
    </button>
  </div>
</mat-dialog-actions>
